import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-custom',
  templateUrl: './modal-custom.component.html'
})
export class ModalCustomComponent {
  @Input() appModalBody: string;
  @Input() appModalBottom: string;

  @Input() id: string;
  @Input() title: string;

}
